import { render, staticRenderFns } from "./EntityBtn.vue?vue&type=template&id=a1cb48d8&scoped=true&"
import script from "./EntityBtn.vue?vue&type=script&lang=js&"
export * from "./EntityBtn.vue?vue&type=script&lang=js&"
import style0 from "./EntityBtn.vue?vue&type=style&index=0&id=a1cb48d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cb48d8",
  null
  
)

export default component.exports